// @flow
import React, { useState } from 'react';
import { isEmpty } from 'lodash';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Breadcrumb from 'react-bootstrap/Breadcrumb';
import { RestaurantActions } from 'modules/restaurant/actions';
import { withRouter } from 'react-router-dom';
import { useViewport } from 'components/templates/viewportProvider';
import { OverlayPortal } from 'components/templates/overlayPortal';
import { OverlayModal } from 'components/templates/overlayModal';
import { RouteNames } from 'router';
import { RouteUtil } from 'utils/RouteUtil';
//eslint-disable-next-line
import styles from "./styles.scss";

type Props = {
  artistsData: Array,
};

const EventHeaderButtons = (props: Props) => {
  const { isMobile } = useViewport();
  const {
    artistsData,
    toggleModal,
    restaurantName,
    location,
    checkForCTAButton = true,
    onGetInTouchClick = true,
    data,
  } = props;
  const [form, showForm] = useState(false);

  const handleClick = link => {
    window.open(link);
  };

  const showModal = val => {
    toggleModal(val);
  };

  const openFormOverlay = () => {
    showForm(true);
    // showModal(false);
  };

  let extractedData = '';
  data &&
    data.banner.map(data => {
      extractedData = data;
    });

  const showOverlay = form ? (
    <OverlayPortal>
      <OverlayModal
        data={extractedData}
        theme={'light-theme'}
        type={'reservation-form'}
        onClosePress={() => showForm(false)}
        location={location}
        formData={data}
        breadcrumbList={[
          {
            breadcrumbName: 'Restaurant',
            breadcrumbLink: RouteNames.restaurants,
          },
          {
            breadcrumbName: restaurantName,
            breadcrumbLink: '#',
          },
        ]}
      />
    </OverlayPortal>
  ) : null;
  const onProjectAnnouncementClick = urlSlug => {
    const redirectionURl = urlSlug;
    if (redirectionURl) {
      const matches =
        redirectionURl.includes('https') ||
        redirectionURl.includes('http') ||
        redirectionURl.toUpperCase().includes('https') ||
        redirectionURl.toLowerCase().includes('https');
      if (!matches) {
        RouteUtil.setRouteChange(props, redirectionURl);
      } else {
        window.location.assign(`${redirectionURl}`);
      }
    }
  };

  const checkAnnouncementURL = urlSlug => {
    if (checkForCTAButton === true && !urlSlug) onGetInTouchClick(true);
    else onProjectAnnouncementClick(urlSlug);
  };
  //TODO: refactor
  return (
    <>
      <Breadcrumb>
        <div className={'restaurant-header-buttons'}>
          {!isEmpty(artistsData) && isMobile
            ? artistsData.map(buttonData => {
                return (
                  <>
                    <h2
                      onClick={() =>
                        checkAnnouncementURL(
                          buttonData.artistIntro.artist_button_link
                        )
                      }
                    >
                      {buttonData.artistIntro.artist_button_name}
                    </h2>
                  </>
                );
              })
            : artistsData.map(buttonData => {
                return (
                  <>
                    <h4
                      onClick={() =>
                        checkAnnouncementURL(
                          buttonData.artistIntro.artist_button_link
                        )
                      }
                    >
                      {buttonData.artistIntro.artist_button_name}
                    </h4>
                  </>
                );
              })}
        </div>
      </Breadcrumb>
      {showOverlay}
    </>
  );
};

const mapDispatchToProps = dispatch => {
  const { toggleModal } = RestaurantActions;
  return bindActionCreators(
    {
      toggleModal,
    },
    dispatch
  );
};

const connectedComponent = connect(
  null,
  mapDispatchToProps
)(EventHeaderButtons);

export default withRouter(connectedComponent);
